module.exports = __webpack_public_path__ + "static/media/Welcome.e8b961da.jpeg";